module.exports = __webpack_public_path__ + "img/shortConfirm.2eebcd8d.png";